import { BatchProcessTypeBase } from './base/batch-process-type-base';

export class BatchProcessType extends BatchProcessTypeBase { }